import React from "react";

/**
 * Shared metadata fields for file upload forms (all modules).
 */
export default function FileUploadMetaFields({
  displayName,
  onDisplayNameChange,
  issueDate,
  onIssueDateChange,
  author,
  onAuthorChange,
  ids = {},
}) {
  const idDisp = ids.display || "upload-display-name";
  const idIssue = ids.issue || "upload-issue-date";
  const idAuth = ids.author || "upload-author";

  return (
    <>
      <div>
        <label htmlFor={idDisp} className="block text-sm font-medium text-gray-700 mb-2">
          Display name <span className="text-red-600">*</span>
        </label>
        <input
          id={idDisp}
          type="text"
          value={displayName}
          onChange={(e) => onDisplayNameChange(e.target.value)}
          className="w-full p-2 border rounded text-[12px]"
          placeholder="e.g. Structural – Issued for Construction"
          required
        />
      </div>

      <div>
        <label htmlFor={idIssue} className="block text-sm font-medium text-gray-700 mb-2">
          Issue date <span className="text-red-600">*</span>
        </label>
        <input
          id={idIssue}
          type="date"
          value={issueDate}
          onChange={(e) => onIssueDateChange(e.target.value)}
          className="w-full p-2 border rounded text-[12px]"
          required
        />
      </div>

      <div>
        <label htmlFor={idAuth} className="block text-sm font-medium text-gray-700 mb-2">
          Author
        </label>
        <input
          id={idAuth}
          type="text"
          value={author}
          onChange={(e) => onAuthorChange(e.target.value)}
          className="w-full p-2 border rounded text-[12px]"
          placeholder="Optional"
        />
      </div>
    </>
  );
}
